import Cookies from 'js-cookie';
import { generateLXCUID } from '@cap/utils';
import { isBrowser, getCookie, getUserAgent, getQueryByName } from '@cap/ssr-common-utils';

const uuidKey = '_lxsdk_cuid';

/**
 * 获取帮助中心端uuid，无uuid参考灵犀算法生成
 * 参考：https://docs.sankuai.com/lx/web/uuid/
 */
export function getLxCUUID() {
  if (!isBrowser) {
    const uuid = getQueryByName('uuid');
    const userAgent = getUserAgent();
    if (uuid) {
      return uuid as string;
    }
    const lxCuid = getCookie(uuidKey);
    if (lxCuid) {
      return lxCuid;
    }
    const id = generateLXCUID(userAgent);
    return id;
  }

  let uuid = Cookies.get(uuidKey);
  if (!uuid) {
    const cacheKey = `_mtdx${uuidKey}`;
    uuid = Cookies.get(cacheKey);
    if (!uuid) {
      uuid = generateLXCUID();
      Cookies.set(cacheKey, uuid, {
        expires: 30, // 过期时间30天
      });
    }
  }
  return uuid;
}
